/**
 * System dockerMgmt Store
 *
 * @since 2017-12-12
 * @author kdydesign.kim
 */

export const state = () => ({
  // api url 목록
  apiUrl: '/api/sm/mfxmgmt',
  settingInfo: {}
})

export const mutations = {
  chgSettingInfo (state, chgInfo) {
    const chgSetInfo = _.clone(chgInfo)
    chgSetInfo['system.docker.stms.cpu_limit'] = Number(chgSetInfo['system.docker.stms.cpu_limit'])
    chgSetInfo['system.docker.stms.mem_limit'] = Number(chgSetInfo['system.docker.stms.mem_limit'])
    state.settingInfo = chgInfo
  }
}

export const actions = {
  // 데몬 실행상태 조회
  async getDemonMgmt ({state}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$get(`${state.apiUrl}`)
      if (res.code === 'ok') {
        state.settingInfo = res.result
      } else {
        state.settingInfo = {}
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  // 데몬 상태 수정
  async setDemonMgmt ({state}, param) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$put(`${state.apiUrl}`, {list: param}, {loading: false, successAlert: false})
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  // 재시작
  async restartDemonMgmt ({state}, param) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$put(`${state.apiUrl}/restart`, {list: param}, {loading: false, successAlert: false})
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  }
}

export const getters = {
}

export const strict = false
